export default "__VITE_ASSET__9c05d94b__"